import { Outlet } from "react-router-dom";
import { ActivitySidebar } from "~/components/admin/activity-sidebar";

export function BookingsLayout() {
  return (
    <div className="flex gap-0 -mx-3 -my-2 md:-mx-4 md:-my-3">
      <div className="flex-1 px-3 py-2 md:px-4 md:py-3 min-w-0">
        <Outlet />
      </div>
      <ActivitySidebar />
    </div>
  );
}
